<template>
  <div class="pb-header">
    <NgHeader
      v-if="translationsLoaded"
      :title-to="routerStore.route.path === '/' ? config.url : '/'"
      :logo="headerLogo"
      :title="headerTitle"
      :title-bold="headerSubtitle"
      :user="user"
      @click-signout="logout"
      @click-signin="login"
      @toggle="headerDropdownToggled"
    >
      <template #subtitle>
        <slot name="subtitle" />
      </template>
      <template v-if="hasStatic && !rootStore.errorPage">
        <slot />
      </template>
      <template v-if="hasResponsive && !rootStore.errorPage" #responsive>
        <slot name="responsive" />
      </template>
    </NgHeader>
    <div class="pb-main-loader">
      <LoadingBar />
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import NgHeader from '@nicolaudie-group/ng-ui-kit/components/NgHeader/NgHeader.vue'
import useHasContent from '@nicolaudie-group/ng-ui-kit/composables/useHasContent'
import useRootStore from '@/stores/root.store'
import useUserStore, { userKey } from '@/stores/user.store'
import useRouterStore from '@/stores/router.store'
import useTranslate from '@/composables/useTranslate'
import useReducedState from '@/composables/useReducedState'
import useLogin from '@/composables/useLogin'
import useLogout from '@/composables/useLogout'
import LoadingBar from '@/components/LoadingBar.vue'
import config from '@/config'

const { translationsLoaded } = useTranslate()

const rootStore = useRootStore()
const userStore = useUserStore()
const routerStore = useRouterStore()

const login = useLogin()
const logout = useLogout()

const headerLogo = 'https://media.n-g.co/Images/Logos/SVG/Nicolaudie-profile-builder.svg'
const headerTitle = 'Profile'
const headerSubtitle = 'Builder'

const user = computed(() => userStore[userKey])

const appsHubDropdownActive = ref(false)
const accountDropdownActive = ref(false)

function headerDropdownToggled(status, context) {
  if (context === 'AppsHub') {
    appsHubDropdownActive.value = status
  }
  if (context === 'AccountDropdown') {
    accountDropdownActive.value = status
  }
}

useReducedState(appsHubDropdownActive, 'dropdowns')
useReducedState(accountDropdownActive, 'dropdowns')

const hasStatic = useHasContent('default')
const hasResponsive = useHasContent('responsive')
</script>

<style lang="scss" src="./PbHeader.scss" />
